// import { STATUS_OK } from "./response_model";

export class ResultModel {
  constructor(result) {
    // if (result == []) {
    //   this.status = "FAIL";
    //   this.data = [];
    //   this.error = "No data";
    //   this.message = result.message;
    // } else {
    //   this.status = result.status;
    //   this.data = result.data;
    //   this.error = result.error;
    //   this.message = result.message;
    // }

    if(result == []) {
      this.status = "FAIL";
      // this.data = null;
      this.data = null;
      this.error = null;
      this.message = null;
    } else {
      this.error = result.error;
      this.message = result.message;
      this.status = result.status;
      this.data = result.data;
      // if(this.status == STATUS_OK) {
      //   this.data = result.data;
      // } else {
      //   this.data = {items: [], _links: {}, _meta: {}};
      // }
    }
  }
}
